import { z } from 'zod';

export const FilterSetDisallowedReason = z
  .enum(['invalid-filter-set-name'])
  .describe('FilterSetDisallowedReason');

export type FilterSetDisallowedReason = z.infer<
  typeof FilterSetDisallowedReason
>;
